const config = {
  googleAnalytics: {
    measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-BL9MS8M2N9', // Default fallback value
  },
  // Add more configuration values here
};

export default config;